<a
  class="op-ian-bell op-app-menu--item-action"
  data-test-selector="op-ian-bell"
  [href]="notificationsPath()"
>
  <svg bell-fill-icon size="small"></svg>
  <ng-container *ngIf="(unreadCount$ | async) as unreadCount">
    <span
      *ngIf="unreadCount !== 0"
      class="op-ian-bell--indicator"
      data-test-selector="op-ian-notifications-count"
      [textContent]="unreadCountText$ | async"
    ></span>
  </ng-container>
</a>
